import { eventData } from 'data/mock-data';

const mock = () => ({
  data: {
    eventData,
  },
});

export default mock;
